import { Link } from 'react-router-dom';
import { SectionHeader } from '../../../shared/components/index.js';

/**
 * Retirada del módulo Leads: solo mostraba IDs de responsable Kommo
 * sin cruce con usuarios del portal — no aporta a la medición comercial.
 */
export default function LeadsDistribucionPage() {
  return (
    <section className="analytics-section">
      <SectionHeader
        title="Distribución por vendedor"
        note="Retirada del módulo Leads."
      />
      <div className="analytics-panel">
        <p className="analytics-empty" style={{ marginBottom: 12 }}>
          Esta vista agrupaba leads abiertos por el <strong>ID de responsable en Kommo</strong>{' '}
          (CRM), sin mapear a nombres del portal. No forma parte de la medición de Leads
          (vía de entrada, embudo, SLA, campañas).
        </p>
        <p className="analytics-section-note" style={{ margin: 0 }}>
          Para seguimiento por persona, usá{' '}
          <Link to="/old/ejecutivos">Ejecutivos</Link> (planillas operativas).
        </p>
      </div>
    </section>
  );
}
